import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class KnowledgeDocumentBody extends PrimitiveValueObject<string> {
  static create(value: string): KnowledgeDocumentBody {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new KnowledgeDocumentBody(value);
  }
}
